import { useMutation, useQueryClient } from '@tanstack/react-query';

import postUpdateGiveawayStock from 'Api/productivity-host/postUpdateGiveawayStock';
import postUpdateGiveawayStockRequest from './model/request/postUpdateGiveawayStockRequest';

import { useToast } from 'Store/toast';
import { hostUpdateGiveawayText } from 'Const/productivity-host/view';

const usePostUpdateGiveawayStock = () => {
  const queryClient = useQueryClient();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (data) => {
      const payload = postUpdateGiveawayStockRequest(data);

      const response = await postUpdateGiveawayStock(payload);

      return response;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['giveaway-brief'] });
    },
    onError: async (error) => {
      onOpenToast({
        description: error?.response?.data?.errors[0]?.message || hostUpdateGiveawayText?.errorDescription,
        status: 'failed',
        duration: 5,
        position: 'top',
        type: 'mobile',
      });
    },
  });
};

export default usePostUpdateGiveawayStock;
